import React from 'react'

import { formatRub } from '@/lib/money'

type BaseProps = {
  className?: string
  currencyCodeClassName?: string
  as?: 'span' | 'p'
}

type PriceFixed = {
  amount: number
  currencyCode?: string
  highestAmount?: never
  lowestAmount?: never
}

type PriceRange = {
  amount?: never
  currencyCode?: string
  highestAmount: number
  lowestAmount: number
}

type Props = BaseProps & (PriceFixed | PriceRange)

/**
 * Валюта у магазина одна — рубль, поэтому форматируем сами (formatRub),
 * а не через formatCurrency плагина: тот всегда печатает две копейки и
 * код валюты латиницей.
 */
export const Price = ({ amount, className, highestAmount, lowestAmount, as = 'p' }: Props & React.ComponentProps<'p'>) => {
  const Element = as

  if (typeof amount === 'number') {
    return (
      <Element className={className} suppressHydrationWarning>
        {formatRub(amount)}
      </Element>
    )
  }

  if (highestAmount && highestAmount !== lowestAmount) {
    return (
      <Element className={className} suppressHydrationWarning>
        {`${formatRub(lowestAmount)} – ${formatRub(highestAmount)}`}
      </Element>
    )
  }

  if (lowestAmount) {
    return (
      <Element className={className} suppressHydrationWarning>
        {formatRub(lowestAmount)}
      </Element>
    )
  }

  return null
}
